import React from "react";
import { OverlayView } from "@react-google-maps/api";
import { Box, Typography, Paper } from "@mui/material";
import { getIcon } from "@dishopsaas/design-system";
import getStyles from "./MapMarker.styles";
import { DRIVER_ICON_URL } from "../../constants";

type Props = {
    lat: number;
    lng: number;
    isDelivery: boolean;
    secondaryColor: string;
    useCustomMarker?: boolean;
    markerInfo?: {
        duration?: number;
        time?: moment.Moment;
    };
    image?: string;
    shopName?: string;
    text?: string;
    showOnlyMap?: boolean;
    isDriver?: boolean
};

const MapMarker: React.FC<Props> = ({
    lat,
    lng,
    isDelivery,
    secondaryColor,
    useCustomMarker = false,
    markerInfo,
    image,
    shopName,
    text,
    showOnlyMap,
    isDriver
}) => {
    const styles = getStyles(secondaryColor);

    return (
        <>
            <OverlayView
                position={{ lat, lng }}
                mapPaneName={OverlayView.FLOAT_PANE}
            >
                {useCustomMarker ? (
                    <Box sx={styles.container}>
                        <Box sx={styles.bigCircle}>
                            <>
                                <Typography sx={styles.duration}>
                                    {markerInfo?.time?.format("HH:mm")}
                                </Typography>
                            </>
                        </Box>
                        <Box sx={styles.linkContainer}>
                            <Box sx={styles.line} />
                            <Box sx={styles.smallCircle} />
                        </Box>
                    </Box>
                ) : (
                    isDriver ? (<Box sx={styles.driverStyle}>
                        <img
                            src={DRIVER_ICON_URL}
                            alt='driver'
                            width={50}
                            height={50}
                        />
                    </Box>) : (
                        <Box sx={styles.defaultMarker}>
                            {getIcon(isDelivery ? "position" : "Store", {
                                width: "100%",
                                height: "100%",
                                color: "white",
                            })}
                        </Box>
                    )
                )}
            </OverlayView>

            {useCustomMarker && !showOnlyMap && (
                <OverlayView
                    position={{ lat, lng }}
                    mapPaneName={OverlayView.FLOAT_PANE}
                >
                    <Paper sx={styles.paperStyle}>
                        <Box
                            sx={{
                                width: "64px",
                                height: "64px",
                                borderRadius: "10px",
                                background: `url(${image})`,
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                            }}
                        />
                        <Box sx={{ p: 3 }}>
                            <Typography variant="subtitle2">{shopName}</Typography>
                            <Typography variant="body1">{text}</Typography>
                        </Box>
                    </Paper>
                </OverlayView>
            )}
        </>
    );
};

export default MapMarker;